export const IS_FIREFOX =
  navigator.userAgent.toLowerCase().indexOf('firefox') > -1
